/* istanbul ignore file -- environment switch between development and production store bootstraps */
/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
import makeDevStore from './dev';
import makeProdStore from './prod';

const makeStore =
  process.env.NODE_ENV === 'development' ? makeDevStore : makeProdStore;

export default makeStore;
